<template>
  <component :is="tag" id="landing-search-bar">
    <div class="section-inner">
      <div class="media">
        <StoryblokComponent
          v-if="blok.media?.length === 1"
          :blok="blok.media[0]"
          class="image"
        />
      </div>
      <div class="search">
        <div class="standalone">
          <h2 v-if="blok.title" class="search-title size-m">
            {{ blok.title }} {{ blok.includeFacilityTypeGroupKey }}
          </h2>
          <PlacesSearchbox
            :include-facility-type-group-key="blok.includeFacilityTypeGroupKey"
          />
        </div>
      </div>
    </div>
  </component>
</template>

<script setup>
const route = useRoute();

const props = defineProps({
  blok: {
    type: Object,
    required: true,
  },
  tag: {
    type: String,
    required: false,
    default: "div",
  },
});
</script>

<style lang="scss">
.background-landing-search-bar {
  background: linear-gradient(to top, var(--solid-01) 50%, #ffffff 50%);
}
</style>
<style lang="scss" scoped>
#landing-search-bar.section {
  position: relative;
  z-index: 1;
  padding: 0;
  background: linear-gradient(to top, var(--solid-01) 50%, #ffffff 50%);
  .section-inner {
    display: flex;
    flex-direction: column;
    align-items: center;
    @include pair-2;
    padding: 1.5rem 1.125rem;
    border-radius: $radius-l;

    @include for-desktop-up {
      display: flex;
      flex-direction: row;
      padding: 5rem 1.125rem;
      .media {
        text-align: center;
        width: 37.5%;
        :deep(.asset-image) {
          max-height: 15rem;
        }
      }
    }

    @include for-desktop-down {
      .image {
        height: 8.75rem;

        :deep(img) {
          height: 100%;
        }
      }
    }

    .image :deep(img) {
      object-fit: contain;
    }

    .search {
      width: 100%;
      margin-bottom: 2.19rem;
      @include for-desktop-up {
        width: 62.5%;
        margin-bottom: 0;
      }
    }
  }
}
.standalone {
  @include for-desktop-up {
    padding-right: 3.25rem;
  }
}
.search-title {
  line-height: 1;
  margin-bottom: 1rem;
  text-align: center;
  @include for-desktop-up {
    text-align: left;
  }
}

:deep(.filters) {
  justify-content: center;
  @include for-desktop-up {
    justify-content: flex-start;
  }
  .filter {
    width: auto;
  }
}
:deep(.places-checkbox) {
  @include size-2xs;
}
</style>
